import {
  Box,
  createStyles,
  makeStyles,
  Step,
  StepButton,
  StepLabel,
  Stepper as StepperComponent,
  StepperProps as StepperComponentProps,
  Typography,
} from '@material-ui/core';
import cn from 'classnames';
import * as React from 'react';
import { useHistory } from 'react-router';
import { TranquiTheme } from '../../containers/App/theme';
import { CssSpreadType } from '../../utils/css-spread-type';
import CustomStepIcon from './CustomStepIcon';

export type StepDataType = {
  label: string;
  title: string;
  route?: string;
};

type StepperProps = Omit<StepperComponentProps, 'children'> & {
  steps: StepDataType[];
  showLabel?: boolean;
  title?: string;
  className?: string;
  isNavigated?: boolean;
  dataTest?: string;
};

const Stepper: React.FC<StepperProps> = (props) => {
  const {
    activeStep,
    alternativeLabel,
    steps,
    showLabel,
    title,
    className,
    isNavigated,
    dataTest,
  } = props;
  // eslint-disable-next-line @typescript-eslint/no-use-before-define
  const classes = useStyles();
  const history = useHistory();

  function Label(label: string, index: number) {
    return (
      <StepLabel StepIconComponent={CustomStepIcon} data-test={`${dataTest}-step-${index}`}>
        {showLabel && label}
      </StepLabel>
    );
  }

  return (
    <Box className={cn(classes.root, className)} data-test={dataTest}>
      {!!title && (
        <Typography className={classes.title} align="center" data-test={`${dataTest}-title`}>
          {title}
        </Typography>
      )}
      <StepperComponent
        activeStep={activeStep}
        alternativeLabel={alternativeLabel}
        className={cn(classes.stepper)}
        data-test={`${dataTest}-content`}
      >
        {steps.map(({ label, route }, index) => (
          <Step key={label}>
            {(isNavigated && !!route) ? (
              <StepButton
                onClick={() => history.push(route as string)}
              >
                {Label(label, index)}
              </StepButton>
            ) : (
              Label(label, index)
            )}
          </Step>
        ))}
      </StepperComponent>
    </Box>
  );
};

const useStyles = makeStyles((theme: TranquiTheme) => createStyles({
  root: {},
  stepper: {
    padding: theme.spacing(3, 0),
  },
  title: {
    ...(theme.typography.small as CssSpreadType),
    color: theme.palette.text5.main,
  },
}));

export default Stepper;
